///
/// EarthBrowser
///
/// Migration v41 to v42: Add sea surface temperature dataset
/// Created by Matt Giger on 9/15/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v41 to v42
 *
 * Changes:
 * - Adds the "sst" (sea surface temperature) dataset type. The layer is
 *   off by default, so persisted state needs no transformation; this
 *   migration only records the version bump that accompanies extending
 *   DatasetType and the validation whitelist.
 */
export function migrateV41toV42(state: unknown): unknown {
	return state
}
